import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = {
  width: "15",
  height: "13",
  viewBox: "0 0 15 13",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createStaticVNode("<path d=\"M3.85156 0.856445L14.2516 0.856445\" stroke=\"#AA1E2D\" stroke-width=\"1.5\" stroke-linecap=\"square\"></path><path d=\"M3.85156 6.45703L14.2516 6.45703\" stroke=\"#AA1E2D\" stroke-width=\"1.5\" stroke-linecap=\"square\"></path><path d=\"M3.85156 12.0566L14.2516 12.0566\" stroke=\"#AA1E2D\" stroke-width=\"1.5\" stroke-linecap=\"square\"></path><rect x=\"0.2\" y=\"0.150195\" width=\"1.5\" height=\"1.5\" fill=\"#AA1E2D\" stroke=\"#AA1E2D\" stroke-width=\"0.1\"></rect><rect x=\"0.2\" y=\"5.75078\" width=\"1.5\" height=\"1.5\" fill=\"#AA1E2D\" stroke=\"#AA1E2D\" stroke-width=\"0.1\"></rect><rect x=\"0.2\" y=\"11.3504\" width=\"1.5\" height=\"1.5\" fill=\"#AA1E2D\" stroke=\"#AA1E2D\" stroke-width=\"0.1\"></rect>", 6)
  ])))
}
export default { render: render }